export default function NotFound() {

  return (
    <div className="main">
      <div className="mt-4 text-3xl font-medium">Page not found</div>

      <div className="mt-4">
        Check the url - we cannot find the page you're looking for
      </div>
    </div>
  );
}